import { configureStore } from '@reduxjs/toolkit';

import applicationReducer from '../common/reducers/applicationSlice';
import applicationSubmissionReducer from '../common/reducers/applicationSubmissionSlice';
import invitationReducer from '../common/reducers/invitationSlice';
import inviteeReducer from '../common/reducers/inviteeSlice';
import teamMemberReducer from '../common/reducers/teamMemberSlice';
import toasterReducer from '../common/reducers/toasterSlice';
import { loadState } from './browers-storage';

export const store = configureStore({
  reducer: {
    toasts: toasterReducer,
    invitees: inviteeReducer,
    invitations: invitationReducer,
    teamMembers: teamMemberReducer,
    applications: applicationReducer,
    applicationSubmission: applicationSubmissionReducer,
  },
  preloadedState: loadState(),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
